

    $(document).ready(function(){

      var bodyWidth = $(window).width();

      $( window ).resize(function() {
        bodyWidth = $(window).width();
      });

      $('.searchSubmit').on('click', function(){
        $('section.header').addClass('searchClicked');
      });

      $('.closeSearchSubmit').on('click', function(){
        $('section.header').removeClass('searchClicked');
        $('.headerMainSearch').val('');
      });

    });
